import * as Columns from './Columns.jsx';
import Name from '../utility/Name.jsx';
import * as NonBreakingContainer from '../common/NonBreakingContainer.jsx';

const Blocks = {
    get: (group, contentType) => {
        return [
            {
                id: Name.Block.Columns,
                component: Columns.Component,
                config: {
                    Block: Columns.TypeConfig.panel.block(contentType),
                    blocks: [[], []],
                    Style: Columns.TypeConfig.panel.style()
                },
                dataBlockType: 'container',
                dataType: 'layout',
                display: 'Columns',
                group,
                image: 'columns.png'
            },
            {
                id: Name.Block.NonBreakingContainer,
                component: NonBreakingContainer.Component,
                config: {
                    Block: NonBreakingContainer.TypeConfig.panel.block(),
                    blocks: [[]],
                    Style: NonBreakingContainer.TypeConfig.panel.style()
                },
                dataBlockType: 'container',
                dataType: 'layout',
                display: 'Non-Breaking',
                group,
                image: ''
            }
        ]
    }
}

export { Blocks };